import React, { Component } from 'react'
export const getParameterByName = (name, url) => {
    if (!url) url = window.location.href
    name = name.replace(/[[\]]/g, '\\$&')
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url)
    if (!results) return null
    if (!results[2]) return ''
    return decodeURIComponent(results[2].replace(/\+/g, ' '))
}

export const postnummerCheck = async postnummer => {
    const response = await fetch(
        `https://webapi.toyota.dk/webapi/api/data/getdealer?postalcode=${postnummer}`
    )
    if (response.status === 200) {
        const json = await response.json()
        let valid = json.Dealers.length > 0
        return json.Dealers[0].District
    } else {
        return false
    }
}
export const createNewline = (text) => {
    let splitText = text.split('\n').map((item,i ) => {
        return <p key={i}>{item}<br/></p>;
    });
    return splitText
}


// WEBPACK FOOTER //
// ./src/component/functions.js